import React from "react";
import { WithStyles, withStyles, Grid, Button, IconButton } from "material-ui";
import { InjectedFormProps, reduxForm } from "redux-form";
import CopyIcon from "material-ui-icons/ContentCopy";

import ExtendedField from "../../../components/form/ExtendedField";
import renderTextField from "../../../components/form/RenderTextField";
import renderSelectField from "../../../components/form/RenderSelectField";

import { AccountDto } from "../../../util/DTOs/AccountDtos";

const styles = {} as React.CSSProperties;

export interface DepositFormData extends AccountDto {}

interface DepositFormProps {
    allAccountsList: { label: string; value: string }[];
    selectedAccountData: AccountDto;
    copyRef: () => void;
}

type DepositPagePropsWithStyles = DepositFormProps &
    InjectedFormProps<DepositFormData, DepositFormProps> &
    WithStyles;

const DepositForm: React.SFC<DepositPagePropsWithStyles> = (props) => {
    const account = props.selectedAccountData;

    return (
        <Grid container>
            <Grid item xs={12}>
                <h4
                    className="hypodgrey"
                    style={{ marginBottom: 0 }}
                    id="selectAccount"
                >
                    Valitse tili, jolle muodostetaan talletusohje:{" "}
                </h4>
                <ExtendedField
                    component={renderSelectField}
                    name="accountNumber"
                    type="select"
                    placeholder=""
                    aria-labelledby="selectAccount"
                    label=""
                    required={false}
                    options={props.allAccountsList}
                />
            </Grid>

            {props.selectedAccountData && (
                <Grid container style={{ marginLeft: 0, marginRight: 0 }}>
                    <Grid item xs={12}>
                        <h3 className="hypoblue">Talletusohje</h3>
                        <p className="hypodgrey">
                            Tee talletus normaalina verkkomaksuna seuraavilla
                            maksutiedoilla:{" "}
                        </p>
                    </Grid>
                    <Grid container style={{ marginBottom: 4 }}>
                        <Grid item xs={4}>
                            <p className="hypodgrey no-margin">Tilille</p>
                        </Grid>
                        <Grid item xs={8}>
                            <p
                                className="hypodgrey no-margin"
                                style={{ fontWeight: "bold" }}
                            >
                                FI47 1660 3000 0635 14
                            </p>
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginBottom: 4 }}>
                        <Grid item xs={4}>
                            <p className="hypodgrey no-margin">Saajana</p>
                        </Grid>
                        <Grid item xs={8}>
                            <p
                                className="hypodgrey no-margin"
                                style={{ fontWeight: "bold" }}
                            >
                                Suomen Asuntohypopankki
                            </p>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4}>
                            <p className="hypodgrey no-margin">Viitenumero</p>
                        </Grid>
                        <Grid item xs={8}>
                            <p
                                id="ref-number"
                                className="hypodgrey no-margin"
                                style={{ fontWeight: "bold" }}
                            >
                                {account.referenceNumber}
                            </p>
                            <Button
                                onClick={props.copyRef}
                                color="primary"
                                size="small"
                                style={{ float: "right" }}
                            >
                                <CopyIcon />
                                Kopioi Viite
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <p className="hypodgrey">
                            Jos teet talletuksen nyt niin se näkyy tililläsi
                            viimeistään 3 pankkipäivän päästä talletuksen
                            tekemisestä.
                        </p>
                        <p className="hypodgrey">
                            Koska Suomen Asuntohypopankki Oy ei ole
                            maksuliikennepankki eikä sinne avattu tilisi ole
                            maksuliikennetili, kaikki maksuliikenne tapahtuu
                            Suomen Asuntohypopankki Oy:n yllä mainitun
                            pankkitilin kautta.
                            <b>
                                {" "}
                                Huom. Viitenumero ohjaa talletuksen tilillesi.
                            </b>
                        </p>
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default reduxForm<DepositFormData, DepositFormProps>({
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(withStyles(styles)(DepositForm));



// WEBPACK FOOTER //
// ./src/views/account/components/depositForm.tsx